module.exports = __webpack_public_path__ + "static/img/introduction-welcome-880937538.b840389.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-welcome-880937538.jpg
// module id = FxGA
// module chunks = 0